import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/download.gif'


const _hoisted_1 = {
  id: "modal-plugin-confirmation",
  class: "modal modal-md fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-3" }
const _hoisted_5 = { class: "d-flex gap-2 align-items-start" }
const _hoisted_6 = { class: "fs-6 text-start" }
const _hoisted_7 = { class: "d-flex gap-2 align-items-start" }
const _hoisted_8 = { class: "d-flex gap-2 align-items-start mb-4" }
const _hoisted_9 = {
  href: "../faq/digital-certificate-plugin",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "link"
}
const _hoisted_10 = { class: "modal-footer py-3" }

import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'

  import { ref, onMounted } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalPluginConfirmation',
  emits: ['retry'],
  setup(__props, { expose: __expose, emit: __emit }) {

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  const fileName = ref<string>('BirdID-Sign-Plugin')

  if (navigator.userAgent.indexOf('Win') !== -1) {
    fileName.value += '.exe'
  }

  if (navigator.userAgent.indexOf('Mac') !== -1) {
    fileName.value += '.dmg'
  }

  const emit = __emit

  onMounted(() => {
    modal.value = new Modal('#modal-plugin-confirmation', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function callAction() {
    emit('retry')
    hide()
  }

  __expose({ show, hide })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-header" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "modal-title mb-5" }, "Execute o plugin em seu computador", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("img", {
            alt: "sucesso",
            src: _imports_0
          }, null, -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "fs-6 text-start mt-4" }, " O plugin é essencial para a emissão do seu Certificado Digital A1. ", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "fs-6 text-start mt-4" }, [
            _createElementVNode("strong", null, "Siga os passos abaixo para executar o arquivo:")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(IconComponent, {
              class: "green pt-1",
              name: "circle-check"
            }),
            _createElementVNode("p", _hoisted_6, [
              _cache[0] || (_cache[0] = _createTextVNode(" Baixe o plugin, ")),
              _createElementVNode("strong", null, "“" + _toDisplayString(fileName.value) + "”", 1),
              _cache[1] || (_cache[1] = _createTextVNode(", em seu computador. "))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(IconComponent, {
              class: "green pt-1",
              name: "circle-check"
            }),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "fs-6 text-start" }, [
              _createTextVNode(" Na pasta de downloads, "),
              _createElementVNode("strong", null, "identifique o arquivo e clique duas vezes para abrir."),
              _createTextVNode(" Ou, com o botão direito do mouse, clique no arquivo e, em seguida, selecione \"Abrir\". ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(IconComponent, {
              class: "green pt-1",
              name: "circle-check"
            }),
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "fs-6 text-start" }, [
              _createElementVNode("strong", null, "Pronto!"),
              _createTextVNode(" Clique no botão abaixo para prosseguir com a instalação do seu Certificado Digital. ")
            ], -1))
          ]),
          _createElementVNode("a", _hoisted_9, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "me-2" }, "Instruções para executar o plugin", -1)),
            _createVNode(IconComponent, { name: "up-right-from-square" })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: callAction
          }, [
            _cache[9] || (_cache[9] = _createTextVNode(" Tudo certo, avançar ")),
            _createVNode(IconComponent, { name: "arrow-right" })
          ])
        ])
      ])
    ])
  ]))
}
}

})